<template>
  <div class="setting-side-content">
    <div class="setting-side-content--side">
      <div class="title">
        {{sideTitle}}
      </div>
      <div class="side-content">
        <slot name="side"/>
      </div>
    </div>
    <div class="setting-side-content--content">
      <slot name="content"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WSettingContentSideTemplate',
  props: {
    sideTitle: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.setting-side-content {
  height: 900px;
  width: 100%;
  $side-width: 300px;

  .setting-side-content--side {
    background: #eee; //$palegray
    border-right: solid 1px #e6e6e6;
    width: $side-width;
    height: 100%;
    float: left;
    box-shadow: inset -1px 0px 5px #f1f1f1;

    $side-title-height: 85px;
    .title {
      height: $side-title-height;
      padding: 20px 0 0 38px;
      font-size: 26px;
      font-weight: bold;
      display: flex;
      align-items: center;
      color: #333;
      letter-spacing: -0.02em;
    }

    .side-content {
      width: 100%;
      padding: 0 15px 15px 15px;
      height: calc(100% - #{$side-title-height});
    }
  }

  .setting-side-content--content {
    float: right;
    width: calc(100% - #{$side-width});
    padding-left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/settings/components/template/SettingContentSideTemplate.vue